import get from './get'
import set from './set'
import update from './update'

export default {
  ...get,
  ...set,
  ...update
}
